import React, {ReactNode} from "react";
import {BtnTypes} from "@/types_and_interfaces/types";
import styles from "@/styles/Ui.module.scss"
import clsx from "clsx";
import {useAtom} from "jotai/index";
import {is_mobile} from "@/atoms/common";


interface Props {
    disabled?:boolean
    type?:BtnTypes
    children:ReactNode
    className?:string
    outlined?:boolean
    onClick?(e?:any):void
    secondary?:boolean
    animated?:boolean
    dark?: boolean,
    light?: boolean
    style?:any
    gray?:boolean
}

const Button:React.FC<Props> = (props) => {
    
    const {
        disabled,
        type,
        children,
        className,
        outlined,
        onClick,
        secondary,
        animated,
        dark,
        light,
        style,
        gray
    } = props
    
    const [mobile] = useAtom(is_mobile)
    
    
    
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            type={type}
            style={style ? style : {}}
            className={clsx(
                styles.standart_button,
                className,
                outlined && styles.outlined,
                secondary && styles.secondary,
                animated && styles.animated,
                mobile && styles.mobile,
                dark && styles.dark,
                light && styles.light,
                gray && styles.gray
            )}
        >
            {children}
        </button>
    )
}

export default Button